import { DialogButton } from "./dialogButton.model";

export class Dialog {
    public buttons = new Array<DialogButton>();
    public buttonPressed: DialogButton; 
}